<template>
    <td-dialog
        :title="$t(title)"
        :before-close="procParamsSetDialogColse"
        :visible.sync="procParamsSetDialogVisible"
        width="1000px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="5vh"
    >
        <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" label-width="150px" type="flex">
            <el-row v-for="(targetTask, targetIndex) in targetTasks" :key="targetIndex" :gutter="20">
                <el-row v-for="(item, index) in targetTask.rowsData" :key="index" :gutter="20">
                    <el-form-item :label="$t(targetTask.targetTaskName + (index + 1))">
                        <el-col v-if="index === 0">
                            <td-button type="text" size="small" @click="addData(targetIndex)">{{ $t('pgCommon.ADD_ORPARAM') }}</td-button>
                        </el-col>
                        <el-col v-if="index !== 0">
                            <td-button type="text" size="small" @click="deleteData(targetIndex, index)">{{ $t('pgCommon.DEL_ORPARAM') }}</td-button>
                        </el-col>
                    </el-form-item>
                    <el-row v-for="(childItem, childIndex) in item" :key="childIndex" :gutter="20" style="margin-bottom: 10px;">
                        <el-col :span="5" :offset="1">
                            <td-select
                                v-model="childItem.key"
                                :options="keys"
                                @change="elementChange(targetTasks, targetIndex, index, childIndex)"
                                :url="viewUrl"
                                :urlParam="viewUrlParam"
                                :isPage="true"
                                :pageSize="10"
                                requestType="POST"
                                keys="sElementFlg"
                                text="sName"
                                :sName="sName"
                                @clear="selectClear(targetTasks, targetIndex, index, childIndex)"
                            ></td-select>
                        </el-col>
                        <el-col :span="5">
                            <td-select v-model="childItem.logic" :options="childItem.logics" keys="value" text="label"></td-select>
                        </el-col>
                        <el-col :span="5">
                            <el-col v-if="!childItem.component">
                                <td-input v-model="childItem.value"></td-input>
                            </el-col>
                            <el-col v-if="childItem.component">
                                <component
                                    :is="childItem.component"
                                    :options="childItem.componentOptions"
                                    :multiple="true"
                                    :keys="childItem.keys"
                                    :text="childItem.text"
                                    v-model="childItem.value"
                                ></component>
                            </el-col>
                        </el-col>
                        <el-col v-if="childIndex === 0" :span="5">
                            <td-button type="text" size="small" @click="addChildDate(index, targetIndex)">{{ $t('pgCommon.ADD_SERIES') }}</td-button>
                        </el-col>
                        <el-col v-if="childIndex !== 0" :span="5">
                            <td-button type="text" size="small" @click="deleteChildDate(childIndex, index, targetIndex)">{{ $t('pgCommon.DEL_SERIES') }}</td-button>
                        </el-col>
                    </el-row>
                </el-row>
                <!-- </el-form-item> -->
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="procParamsSetDialogColse">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import HashMap from 'hashmap';
import Api from '../assets/api.js';
export default {
    props: ['timeLable', 'item', 'procParamsSetDialogVisible', 'title', 'templateKey'],
    created() {
        this.initPage();
    },
    mounted() {
        this.initEdit();
    },
    // 定义变量
    data() {
        return {
            i: 0,
            keysMaps: new HashMap(),
            textMaps: new HashMap(),
            componentOptionsMap: new HashMap(),
            infoMap: new HashMap(),
            component: '',
            viewUrl: '/extendManage/listProcessElementInfo',
            viewUrlParam: {
                sId: this.templateKey + ':'
            },
            keys: [],
            logics: [
                {
                    value: '==',
                    label: this.$t('pgCommon.EQUALS')
                },
                {
                    value: '!=',
                    label: this.$t('pgCommon.UNEQUALS')
                },
                {
                    value: '>=',
                    label: this.$t('pgCommon.GREAT_EQUALS')
                },
                {
                    value: '<=',
                    label: this.$t('pgCommon.LESS_EQUALS')
                },
                {
                    value: '>',
                    label: this.$t('pgCommon.GREAT')
                },
                {
                    value: '<',
                    label: this.$t('pgCommon.LESS')
                }
            ],
            logics1: [
                {
                    value: 'in',
                    label: this.$t('pgCommon.BELONG_TO')
                },
                {
                    value: 'unin',
                    label: this.$t('pgCommon.NOTBELONG_TO')
                }
            ],
            targetTasks: [],
            visibleDate: false,
            visibleWeek: false,
            paraObj: {
                key: '',
                logic: '',
                value: ''
            },
            rowsWeek: [
                {
                    startWeek: '',
                    startTime: '',
                    endWeek: '',
                    endTime: ''
                }
            ],
            weekList: [
                {
                    value: this.$common.week.MONDAY,
                    text: this.$t('common.MONDAY')
                },
                {
                    value: this.$common.week.TUESDAY,
                    text: this.$t('common.TUESDAY')
                },
                {
                    value: this.$common.week.WEDNESDAY,
                    text: this.$t('common.WEDNESDAY')
                },
                {
                    value: this.$common.week.THURSDAY,
                    text: this.$t('common.THURSDAY')
                },
                {
                    value: this.$common.week.FRIDAY,
                    text: this.$t('common.FRIDAY')
                },
                {
                    value: this.$common.week.SATURDAY,
                    text: this.$t('common.SATURDAY')
                },
                {
                    value: this.$common.week.SUNDAY,
                    text: this.$t('common.SUNDAY')
                }
            ]
        };
    },
    destroyed() {
        this.keysMaps.clear();
        this.textMaps.clear();
        this.componentOptionsMap.clear();
        this.infoMap.clear();
    },
    watch: {
        // eslint-disable-next-line no-unused-vars
        i: function(o, m) {
            if (o == this.componentOptionsMap.size) {
                this.initDatas();
            }
        }
    },
    computed: {
        addImg: function() {
            return 'plugins/TdPluginAlarmLinkage/web/' + window.vue.$store.state.skin + '/add.png';
        },
        delImg: function() {
            return 'plugins/TdPluginAlarmLinkage/web/' + window.vue.$store.state.skin + '/del.png';
        }
    },
    // 定义并实现方法体
    methods: {
        selectClear(targetTasks, targetIndex, index, childIndex) {
            targetTasks[targetIndex].rowsData[index][childIndex].logics = [];
        },
        // 保存条件逻辑
        // eslint-disable-next-line no-unused-vars
        submitForm(formInfo) {
            let delPara = {
                proDefKey: this.templateKey,
                taskKey: this.item.taskKey
            };
            Api.deleteActFlowParamsByTask(delPara, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('templateManage/deleteActFlowParamsByTask', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('templateManage/deleteActFlowParamsByTask', response.data.statusMessage);
                    return;
                }
                for (let index in this.targetTasks) {
                    let item = this.targetTasks[index];
                    for (let itemIndex in item.rowsData) {
                        let obj = {};
                        let logic = [];
                        for (let objIndex in item.rowsData[itemIndex]) {
                            if (
                                null != item.rowsData[itemIndex][objIndex].key &&
                                '' != item.rowsData[itemIndex][objIndex].key &&
                                null != item.rowsData[itemIndex][objIndex].value &&
                                '' != item.rowsData[itemIndex][objIndex].value &&
                                null != item.rowsData[itemIndex][objIndex].logic &&
                                '' != item.rowsData[itemIndex][objIndex].logic
                            ) {
                                obj[item.rowsData[itemIndex][objIndex].key] = item.rowsData[itemIndex][objIndex].value;
                                logic.push(item.rowsData[itemIndex][objIndex].logic);
                            }
                        }
                        if (obj && '{}' != obj && logic && '' != logic) {
                            let saveFlag = true;
                            let param = {
                                proDefKey: this.templateKey,
                                taskKey: this.item.taskKey,
                                targetTaskKey: item.targetTaskKey,
                                objJson: JSON.stringify(obj),
                                logicJson: logic.toString()
                            };
                            Api.saveActFlowParams(param, response => {
                                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                                    this.$log.error('templateManage/saveActFlowParams', response);
                                    return;
                                }
                                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                    this.$log.error('templateManage/saveActFlowParams', response.data.statusMessage);
                                    return;
                                }
                                if (saveFlag) {
                                    saveFlag = false;
                                    this.$message({ showClose: true, message: this.$t('pgCommon.SAVE_SUCCESS'), type: 'success' });
                                    this.procParamsSetDialogColse();
                                }
                            });
                        } else {
                            this.$message({ showClose: true, message: this.$t('pgCommon.SAVE_SUCCESS'), type: 'success' });
                            this.procParamsSetDialogColse();
                        }
                    }
                }
            });
        },
        elementChange(targetTasks, targetIndex, index, childIndex) {
            //控制中间的select值
            targetTasks[targetIndex].rowsData[index][childIndex].logic = '';
            if (
                'TdCheckboxGroup' == this.infoMap.get(targetTasks[targetIndex].rowsData[index][childIndex].key) ||
                'TdSelect' == this.infoMap.get(targetTasks[targetIndex].rowsData[index][childIndex].key)
            ) {
                targetTasks[targetIndex].rowsData[index][childIndex].logics = this.logics1;
            } else {
                targetTasks[targetIndex].rowsData[index][childIndex].logics = this.logics;
            }

            targetTasks[targetIndex].rowsData[index][childIndex].value = '';
            //标签元素
            targetTasks[targetIndex].rowsData[index][childIndex].component = this.infoMap.get(targetTasks[targetIndex].rowsData[index][childIndex].key);
            if ('TdCheckboxGroup' == this.infoMap.get(targetTasks[targetIndex].rowsData[index][childIndex].key)) {
                targetTasks[targetIndex].rowsData[index][childIndex].component = 'TdSelect';
            }
            //Options值
            targetTasks[targetIndex].rowsData[index][childIndex].componentOptions = this.componentOptionsMap.get(targetTasks[targetIndex].rowsData[index][childIndex].key);
            //keys
            targetTasks[targetIndex].rowsData[index][childIndex].keys = this.keysMaps.get(targetTasks[targetIndex].rowsData[index][childIndex].key);
            //text
            targetTasks[targetIndex].rowsData[index][childIndex].text = this.textMaps.get(targetTasks[targetIndex].rowsData[index][childIndex].key);
        },
        // 初始化编辑数据
        initEdit() {
            // eslint-disable-next-line no-unused-vars
            let param = {
                proDefKey: this.templateKey,
                taskKey: this.item.taskKey
            };
        },
        // 初始化页面
        initPage() {
            let params = {
                pageNum: 1,
                currentPage: 1,
                pageSize: 100,
                isPage: true,
                sId: this.templateKey + ':'
            };
            let _this = this;
            Api.listProcessElementInfo(params, response => {
                let temp = response.data.content;
                if (temp.length == 0) {
                    _this.initDatas();
                    return;
                }
                _this.component = temp[0].sElementType;
                for (let i = 0; i < temp.length; i++) {
                    if (temp[i].sElementType == '' || temp[i].sElementType == null) {
                        _this.infoMap.set(temp[i].sElementFlg, '');
                    } else {
                        //存储标签类型
                        _this.infoMap.set(temp[i].sElementFlg, temp[i].sElementType);
                    }
                    if (temp[i].sOptionData == '' || temp[i].sOptionData == null) {
                        _this.componentOptionsMap.set(temp[i].sElementFlg, '');
                    } else {
                        //存储标签值
                        _this.componentOptionsMap.set(temp[i].sElementFlg, Array.from(JSON.parse(temp[i].sOptionData)));
                    }
                }
                let a = 0;
                _this.componentOptionsMap.forEach(function(value, key) {
                    if (value.length == 0) {
                        let paramss = {
                            page: false,
                            sgroupId: params.sId + _this.item.taskKey,
                            selementId: params.sId + key,
                            selementKey: key
                        };
                        Api.checkElementKey(paramss, response => {
                            if (response.data.content == null) {
                                ++a;
                                _this.i = a;
                            } else {
                                let targetUrl = JSON.parse(response.data.content[0].sElementPropsJson);
                                //是否有url
                                if (targetUrl.url != undefined) {
                                    let url = targetUrl.url;
                                    let urlParam = '';
                                    let isPages = false;
                                    if (targetUrl.urlParam == undefined || targetUrl.urlParam == null) {
                                        urlParam = { isPage: isPages };
                                    } else {
                                        urlParam = targetUrl.urlParam;
                                    }
                                    let targetUrKeys = targetUrl.keys;
                                    let targetUrText = targetUrl.text;
                                    if (targetUrKeys != '' && targetUrKeys != null && targetUrKeys != undefined) {
                                        _this.keysMaps.set(key, targetUrKeys);
                                    } else {
                                        _this.keysMaps.set(key, 'value');
                                    }
                                    if (targetUrText != '' && targetUrText != null && targetUrText != undefined) {
                                        _this.textMaps.set(key, targetUrText);
                                    } else {
                                        _this.textMaps.set(key, 'label');
                                    }
                                    let requestType = targetUrl.requestType;
                                    if (requestType == 'POST') {
                                        window.vue.$apiAxios.postRequestBody(url, urlParam, response => {
                                            let rs = response.data.content;
                                            if (response.data.statusCode == _this.$common.requestCode.SUCCESS_INFO_CODE) {
                                                _this.componentOptionsMap.set(key, rs);
                                                ++a;
                                                _this.i = a;
                                            } else {
                                                ++a;
                                                _this.i = a;
                                            }
                                        });
                                    } else if (requestType == 'GET') {
                                        window.vue.$apiAxios.get(url, urlParam, response => {
                                            let rs = response.data.content;
                                            if (response.data.statusCode == _this.$common.requestCode.SUCCESS_INFO_CODE) {
                                                _this.componentOptionsMap.set(key, rs);
                                                ++a;
                                                _this.i = a;
                                            } else {
                                                ++a;
                                                _this.i = a;
                                            }
                                        });
                                    } else {
                                        ++a;
                                        _this.i = a;
                                    }
                                } else {
                                    ++a;
                                    _this.i = a;
                                }
                            }
                        });
                    } else {
                        ++a;
                        _this.i = a;
                    }
                });
            });
        },
        initDatas() {
            let param = {
                templateId: this.item.templateId,
                taskKey: this.item.taskKey
            };
            Api.getTaskOutgoings(param, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('templateManage/getTaskOutgoings', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('templateManage/getTaskOutgoings', response.data.statusMessage);
                    return;
                }
                var initData = response.data.content;
                let flowParam = {
                    proDefKey: this.templateKey,
                    taskKey: this.item.taskKey
                };
                Api.getFlowParams(flowParam, response => {
                    if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                        this.$log.error('templateManage/getFlowParams', response);
                        return;
                    }
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('templateManage/getFlowParams', response.data.statusMessage);
                        return;
                    }
                    for (let index in initData.targetTaskKeys) {
                        let targetTask = {
                            targetTaskKey: initData.targetTaskKeys[index],
                            targetTaskName: initData.targetTaskNames[index] + '环节条件',
                            rowsData: [
                                [
                                    {
                                        key: '',
                                        logic: '',
                                        value: ''
                                    }
                                ]
                            ]
                        };
                        this.targetTasks.push(targetTask);
                    }
                    for (let targetIndex in this.targetTasks) {
                        let orIndex = 0;
                        for (let objIndex in response.data.content) {
                            if (this.targetTasks[targetIndex].targetTaskKey == response.data.content[objIndex].sToKey) {
                                if (orIndex > 0) {
                                    this.addData(targetIndex);
                                }
                                let obj = JSON.parse(response.data.content[objIndex].sObjJson);
                                let keys = Object.keys(obj);
                                let logics = response.data.content[objIndex].sLogicEng.split(',');
                                for (let paraIndex in keys) {
                                    if (paraIndex > 0) {
                                        this.addChildDate(orIndex, targetIndex);
                                    }
                                    this.targetTasks[targetIndex].rowsData[orIndex][paraIndex].key = keys[paraIndex];
                                    this.targetTasks[targetIndex].rowsData[orIndex][paraIndex].logic = logics[paraIndex];
                                    this.targetTasks[targetIndex].rowsData[orIndex][paraIndex].value = obj[keys[paraIndex]];
                                    this.targetTasks[targetIndex].rowsData[orIndex][paraIndex].logics =
                                        this.infoMap.get(keys[paraIndex]) === 'TdSelect' || this.infoMap.get(keys[paraIndex]) === 'TdCheckboxGroup' ? this.logics1 : this.logics;
                                    this.targetTasks[targetIndex].rowsData[orIndex][paraIndex].component =
                                        this.infoMap.get(keys[paraIndex]) === 'TdCheckboxGroup' ? 'TdSelect' : this.infoMap.get(keys[paraIndex]);
                                    this.targetTasks[targetIndex].rowsData[orIndex][paraIndex].componentOptions = this.componentOptionsMap.get(keys[paraIndex]);
                                    this.targetTasks[targetIndex].rowsData[orIndex][paraIndex].keys = this.keysMaps.get(keys[paraIndex]);
                                    this.targetTasks[targetIndex].rowsData[orIndex][paraIndex].text = this.textMaps.get(keys[paraIndex]);
                                }
                                orIndex = orIndex + 1;
                            }
                        }
                    }
                });
            });
        },
        // 新增并联条件
        addData(targetIndex) {
            let rowsData = [
                {
                    key: '',
                    logic: '',
                    value: ''
                }
            ];
            this.targetTasks[targetIndex].rowsData.push(rowsData);
        },
        // 删除并联条件
        deleteData(targetIndex, index) {
            this.targetTasks[targetIndex].rowsData.splice(index, 1);
        },
        // 添加串联条件
        addChildDate(index, targetIndex) {
            let para = {
                key: '',
                logic: '',
                value: ''
            };
            this.targetTasks[targetIndex].rowsData[index].push(para);
        },
        // 删除串联条件
        deleteChildDate(childIndex, index, targetIndex) {
            this.targetTasks[targetIndex].rowsData[index].splice(childIndex, 1);
        },
        procParamsSetDialogColse() {
            this.procParamsSetDialogVisible = false;
            this.$emit('procParamsSetDialogColse');
        }
    }
};
</script>
